<template>
  <div class="content_container">
      <el-tabs v-model="activeTab" class="tabs">
        <el-tab-pane label="视频列表" name="tab1">
          <el-scrollbar>
            <div class="container">
            <div class="video_list">
              <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" class="ors_table">
                    <!-- <el-table-column align="center" :show-overflow-tooltip="true" type="selection" width="50">
                    </el-table-column> -->
                    <el-table-column align="center" :show-overflow-tooltip="true" label="序号" prop='file_id' width="60">
                    </el-table-column>
                    <el-table-column align="center" :show-overflow-tooltip="true" label="缩略图" prop='thumb' width="100">
                      <template slot-scope="scope">
                        <img :src="scope.row.thumb" alt="" class="thumbImg">
                      </template>
                    </el-table-column>
                    <el-table-column align="center" :show-overflow-tooltip="true" label="文件名称" prop='file_name'>
                    </el-table-column>
                    <el-table-column align="center" :show-overflow-tooltip="true" label="发布人" prop='creater' width="100">
                    </el-table-column>
                    <el-table-column align="center" :show-overflow-tooltip="true" label="发布时间" prop='created_t'>
                    </el-table-column>
                    <el-table-column align="center" :show-overflow-tooltip="true" label="操作" width="180">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewEdit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="deleteVideo(scope.row.file_id)">删除</el-button>
                        <el-button type="text" size="small" @click="viewUrlHandle(scope.row.file_url)">查看地址</el-button>
                      </template>
                  </el-table-column>
                </el-table>
                <div class="paginate">
                  <el-pagination
                    layout="prev, pager, next"
                    :hide-on-single-page="true"
                    @current-change="clickPage"
                    :total="total">
                  </el-pagination>
                </div>
            </div>
          </div>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
            <!-- 编辑 -->
		<el-dialog custom-class="ors_tc upload_video" title="编辑" :visible.sync="EditVideo" width="480px">
		    <el-form ref="form" :model="editVideo" label-width="70px">
		    	<el-form-item label="缩略图">
		        	<el-upload
						class="uploadThumbImg"
            accept=".jpg,.jpeg,.png"
						:action="uploadThumbUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
						:on-success="handleAvatarSuccess"
						>
						<img v-if="editVideo.thumb" :src="editVideo.thumb" class="thumbImg">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<div class="el-upload__tip">
						支持JPG/PNG格式，图片比例1.5：1<br />
						图片大小不超过1MB
					</div>
		        </el-form-item>
		        <el-form-item label="文件名称">
				    <el-input type="text" v-model="editVideo.file_name"></el-input>
				</el-form-item>
				<el-form-item label="描述">
				    <el-input 
			        type="textarea" 
			        placeholder="请输入内容"
			        v-model="editVideo.file_introduce"
			        rows='4'
			        maxlength="200"
			        show-word-limit>
			        </el-input>
				</el-form-item>
			</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button size="small" @click="cancelViewVideo">取 消</el-button>
		        <el-button size="small" type="primary" @click="subEditVideo">保存</el-button>
		    </span>
		</el-dialog>

		<!-- 查看地址 -->
		<el-dialog custom-class="ors_tc" title="查看地址" :visible.sync="viewUrl" width="480px">
		    <el-form>
		    	<div class="form_block">
		    		<div class="form_item">
				        <el-input type="text" v-model='videoUrl'></el-input>
		    		</div>
	    		</div>
			</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button size="small" @click="viewUrl = false">取 消</el-button>
		        <el-button size="small" type="primary" v-clipboard:copy="videoUrl" 
             v-clipboard:success="copySuccess"
             v-clipboard:error="copyError">复制</el-button>
		    </span>
		</el-dialog>
  </div>
</template>

<script>
import "@/plugins/clipboard.js";//剪切板
export default {
  data(){
    return {
      activeTab: 'tab1', //当前tab
      EditVideo: false, //编辑视频
      viewUrl: false, //查看地址 
      uploadThumbUrl:process.env.VUE_APP_API_URL + '/api/uploadThumb',
      uploadHeaders:{Authorization:window.localStorage.getItem('token')},
      pagesize:10,
      page:1,
      total:0,
      tableData:[], 
      videoUrl: '', 
      editVideo:{},
      subEditStatus:false,
      userType:2
    }
  },
  mounted(){
    this.setUserInfo()
    this.getMultiList();
  },
  watch:{
    'page':'getMultiList'
  },
  methods:{
    setUserInfo(){
        let that = this;
        this.$API('/api/userInfo','get',{},function(response){
            if(response.code === 200){ 
                that.userType = response.data.type;
            }
        });
    },
    clickPage(page){
      this.page=page;
    },
    getMultiList(){
      let pagesize = this.pagesize;
      let page = this.page;
      let that = this;
      this.$API('/api/multiList','get',{pagesize:pagesize,page:page},function(response){
        if(response.code === 200){
          for(let item of response.data.data){
            item.thumb=process.env.VUE_APP_API_URL + item.file_thumb;
          }
          that.tableData = response.data.data;
          that.total=response.data.total;
        }
      });
    },
    viewUrlHandle(url){
      this.videoUrl=url;
      this.viewUrl=true;
    },
    copySuccess(){
      this.$ok('复制成功');
      this.viewUrl=false;
      this.videoUrl='';
    },
    copyError(){
      this.$error('您的浏览器暂不支持一键复制');
    },
    viewEdit(data){
      this.editVideo = data;
      this.EditVideo=true;
    },
    cancelViewVideo(){
      this.EditVideo=false; 
      this.editVideo={};
    },
    subEditVideo(){
      if(this.subEditStatus){
        this.$warning();
        return false;
      }else{
        this.subEditStatus=true;
      }

      let that = this;
      let _data = {
        file_id:this.editVideo.file_id,
        file_name:this.editVideo.file_name,
        file_thumb:this.editVideo.file_thumb,
        file_introduce:this.editVideo.file_introduce,
      };

      
      if(_data.file_thumb === ''){
        this.$error('请上传缩略图');
        this.subEditStatus=false;
      }
      if(_data.file_name === ''){
        this.$error('请填写文件名称');
        this.subEditStatus=false;
      }
      if(_data.file_introduce === ''){
        this.$error('请填写描述');
        this.subEditStatus=false;
      }

      this.$API('/api/multiUpdate','post',_data,function(response){
        if(response.code === 200){
          that.$ok(response.message);
          that.getMultiList();
          that.cancelViewVideo();
        }else{
          that.$error(response.message);
        }
      },function(){
        that.subEditStatus=false;
      });
    },
    handleAvatarSuccess(res) {
      if(res.code===200){
          this.editVideo.file_thumb = res.data.thumb_url;
          this.editVideo.thumb = process.env.VUE_APP_API_URL + res.data.thumb_url; 
        
        }else{
          this.$error(res.message);
        }
    },
      // 删除视频
    deleteVideo(id) {
      this.$confirm('确认删除该参赛视频？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(()=>{
          let that = this;
          this.$API('/api/multiDel','post',{id:id},function(response){
            if(response.code === 200){
              that.$ok(response.message);
              that.getMultiList();
            }else{
              that.$error(response.message);
            }
          });
      }).catch(() => {});
    }
  }
}
</script>

<style>
  .paginate{
    float:right;
  }
</style>